import React, { memo, MouseEventHandler } from 'react'
import { Button } from 'transfix-ui/components/Button'

export interface ITopNavCTAProps {
  label: string
  large?: boolean
  url?: string
  onClick?: MouseEventHandler
  dataTest?: string
  startIcon?: React.ReactNode
}

export const TopNavCTA = memo<ITopNavCTAProps>(
  ({ dataTest = 'topnav-primary-cta', label, large, onClick = () => {}, startIcon, url }) => (
    <div>
      {url ? (
        <a href={url} rel='noopener noreferrer' className='btn btn-primary' data-test={dataTest}>
          {label}
        </a>
      ) : (
        <Button
          color='primary'
          onClick={onClick}
          size={large ? 'large' : 'medium'}
          startIcon={startIcon}
          data-test={dataTest}>
          {label}
        </Button>
      )}
    </div>
  )
)
